<template>
  <label class="base-checkbox">
    <input
      :class="[checked ? 'checked' : '']"
      type="checkbox"
      :checked="checked"
      :value="value"
      @input="$emit('input', $event.target.checked)"
      :required="required"
    >
    <BaseText6 :text="label"/>
  </label>
</template>

<script>
import BaseText6 from '@/components/BaseText6/BaseText6'
export default {
  components: {
    BaseText6
  },
  props: {
    checked: {
      type: Boolean,
      required: true
    },
    value: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.base-checkbox {
  display: flex;
  align-items: center;
}
input {
  position: relative;
  width: 1rem;
  height: 1rem;
  border: solid var(--color-white-1) 1px;
  margin-right: 1rem;
}
input.checked::after {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  content: '';
  background-image: url('../../assets/img/tick.svg');
  background-size: 65%;
  background-repeat: no-repeat;
  background-position: center center;
}
</style>
